import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const UpdateNewsMedia = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.state?.id;

  const [year, setYear] = useState("");
  const [artist, setArtist] = useState("");
  const [category, setCategory] = useState("");
  const [title, setTitle] = useState("");
  const [media, setMedia] = useState("");
  const [datePosted, setDatePosted] = useState("");
  const [link, setLink] = useState("");
  const [thumbnail, setThumbnail] = useState<File | null>(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, [id]);

  const fetchData = async (id: number) => {
    try {
      const authToken = localStorage.getItem("authToken");
      const response = await axios.get(
        `https://cdn.pulp.ph/api/v1/pulpliveworld/news-media/${id}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data.NewsMedia;

      setYear(data.Year || "");
      setArtist(data.Artist || "");
      setCategory(data.Category || "");
      setTitle(data.Title || "");
      setMedia(data.Media || "");
      setDatePosted(data.DatePosted || "");
      setLink(data.Link || "");
      setThumbnail(data.Thumbnail || null); // Set the existing thumbnail if available
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to fetch data. Please try again.");
      setLoading(false);
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setThumbnail(e.target.files[0]);
      console.log("Selected File:", e.target.files[0]);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const authToken = localStorage.getItem("authToken");

      // Create a FormData object and append all fields
      const formData = new FormData();
      formData.append("Year", year);
      formData.append("Artist", artist);
      formData.append("Category", category);
      formData.append("Title", title);
      formData.append("Media", media);
      formData.append("DatePosted", datePosted);
      formData.append("Link", link);

      // Append the Thumbnail file if it exists
      if (thumbnail && typeof thumbnail !== "string") {
        formData.append("Thumbnail", thumbnail);
      }

      // Debug log for FormData
      console.log("FormData being sent:");
      for (const [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      const response = await axios.post(
        `https://cdn.pulp.ph/api/v1/pulpliveworld/news-media/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("API Response:", response.data);
      alert("News Media updated successfully!");
      navigate("/view/post/news-media");
    } catch (err) {
      console.error("Error updating News Media:", err);
      if (axios.isAxiosError(err)) {
        console.error("Error Response:", err.response?.data);
        alert(
          err.response?.data?.message ||
            "Failed to update News Media. Please try again."
        );
      } else {
        alert("Failed to update News Media. Please try again.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="container mx-auto p-6 bg-gray-100 rounded-md shadow-md">
      <h1 className="text-2xl font-bold mb-6">News Media Editor</h1>
      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-1 md:grid-cols-2 gap-6"
      >
        <div>
          <label className="block font-medium mb-1">Year:</label>
          <input
            type="number"
            value={year}
            onChange={(e) => setYear(e.target.value)}
            className="w-full border border-gray-300 rounded p-2 bg-gray-100"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Artist:</label>
          <input
            type="text"
            value={artist}
            onChange={(e) => setArtist(e.target.value)}
            className="w-full border border-gray-300 rounded p-2 bg-gray-100"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Category:</label>
          <input
            type="text"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="w-full border border-gray-300 rounded p-2 bg-gray-100"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Title:</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full border border-gray-300 rounded p-2 bg-gray-100"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Media:</label>
          <input
            type="text"
            value={media}
            onChange={(e) => setMedia(e.target.value)}
            className="w-full border border-gray-300 rounded p-2 bg-gray-100"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Date Posted:</label>
          <input
            type="date"
            value={datePosted}
            onChange={(e) => setDatePosted(e.target.value)}
            className="w-full border border-gray-300 rounded p-2 bg-gray-100"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Link:</label>
          <input
            type="url"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            className="w-full border border-gray-300 rounded p-2 bg-gray-100"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Thumbnail:</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="w-full border border-gray-300 rounded p-2 bg-gray-100"
          />
          {thumbnail && typeof thumbnail === "string" && (
            <p className="text-sm mt-1">Current Thumbnail: {thumbnail}</p>
          )}
        </div>
        <div className="col-span-1 md:col-span-2 flex justify-end">
          <button
            type="submit"
            disabled={isSubmitting}
            className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600 disabled:opacity-50"
          >
            {isSubmitting ? "Updating..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateNewsMedia;
